import React from 'react'

const Separator = ({ separator }) =><div className="separator">{separator}</div>


export default Separator
